// The Comic Machine - Canvas

var Canvas = (function() {

  // Configuration settings/properties
  var config = {
    canvas: {
      width: 1024,
      height: 768,
      offset: 100
    },
    stage: {
      width: 0,
      height: 0
    }
  };

  // A Canvas object to be managed by the Canvas Manager
  function Canvas(options) {

    options = options || {};
    var canvas = this;

    // Set width, height and scale defaults if not preset
    var width = options.width || Canvas.size.width;
    var height = options.height || Canvas.size.height;
    var scale = options.scale || 1; // HACK: window.devicePixelRatio;

    // Set the layer UUID
    this.uuid = options.uuid || null;

    // Set the ID incrementally based on layer count
    if (options.page) {
      this.page = options.page;
      if (options.page.pageLayers) {
        this.id = options.page.pageLayers.length;
      }
    }

    this.layer = options.layer || null;

    // Create canvas element, if not present, then get the context
    this.element = options.element || document.createElement("canvas");
    this.context = this.element.getContext("2d");

    // Events relating to this canvas
    this.events = new Events();

    // this.element.addEventListener("mousemove", function(event) {
    //    canvas.events.emit("mousemove", event);
    // }, false);

    // Set the size and scale of the canvas
    this.setSize(width, height, scale);
    this.setScale(scale, true);

  }

  // Keeps track of the canvas width, height and offset
  Canvas.size = {
    width: config.canvas.width,
    height: config.canvas.height,
    offset: config.canvas.offset
  };

  // Keeps track of the stage width and height
  Canvas.stage = {
    width: config.stage.width,
    height: config.stage.height
  };

  // Draws the canvas on the stage
  Canvas.drawCanvas = function(context, offset) {
    context = context || Canvas.base.context;
    offset = offset || Canvas.size.offset;
    // White semi-transparent background
    context.fillStyle = "rgba(255, 255, 255, 0.9)";
    // 1024x768 ratio canvas
    context.fillRect(
      offset, offset, Canvas.size.width, Canvas.size.height
    );
  };

  // Loads an image and draws it to the canvas
  Canvas.loadImage = function(src, name, callback) {
    var image = document.createElement("img");
    // On image load, fire the callback, if present
    image.onload = function(event) {
      callback && callback(image, name);
    };
    // Set the src of the image
    image.src = src;
  };

  // Reads the file from the disk
  Canvas.readFile = function(file, callback) {
    //	Reject non-images
    if (!file || !file.type || !file.type.match(/image.*/)) {
      return console.warn("file not an image: ", file);
    }
    //	Create FileReader instance
    var reader = new FileReader();
    // On load of the image file
    reader.onload = function(event) {
      callback && callback(event.target.result, file.name);
    };
    // Read the file as a data URL
    reader.readAsDataURL(file);
    // Return the name or null
    return file.name || null;
  };

  // Method to reset the canvas contents
  Canvas.prototype.resetCanvas = function() {
    var width = this.element.width;
    var height = this.element.height;
    this.element.width = 0;
    this.element.height = 0;
    // Setting the canvas size will reset the canvas contents
    this.element.width = width;
    this.element.height = height;
  };

  // Method to draw an image on the canvas
  Canvas.prototype.drawImage = function(image, coordinates, offset) {

    if (!image) return; // || !this.canvas

    var hasWidth = image.width && image.width !== 0; // image.naturalWidth
    var hasHeight = image.height && image.height !== 0; // image.naturalHeight
    // var isComplete = image.complete === false;

    // Set default coordinates for the image
    coordinates = coordinates || {
      x: 0,
      y: 0
    };
    offset = offset || {
      x: image.width,
      y: image.height
    };

    if (!hasWidth || !hasHeight) { //  || isComplete
      return;
    }

    this.context.drawImage(
      image,
      coordinates.x, coordinates.y,
      offset.x, offset.y
    );

  };

  // Method to draw a circle on the canvas
  Canvas.prototype.drawCircle = function(circle, stroke, fill, handle) {

    fill = fill || "rgba(0, 0, 0, " + (stroke ? "0.25" : "0.75") + ")";
    stroke = stroke || "rgba(255, 255, 255, 0)";

    Canvas.base.context.save();
    Canvas.base.context.beginPath();
    Canvas.base.context.arc(circle.x, circle.y, circle.radius, 0, 2 * Math.PI);
    Canvas.base.context.strokeStyle = stroke;
    Canvas.base.context.fillStyle = fill;
    Canvas.base.context.lineWidth = 2;
    Canvas.base.context.stroke();
    Canvas.base.context.fill();
    Canvas.base.context.restore();

    if (handle === true) {
      Canvas.base.handles.push(circle);
    }

  };

  // Method to draw handles on layer
  Canvas.prototype.drawHandles = function(layer, coordinates, size) {

    size = size || {};

    var image = layer.canvas.element;
    var stroke = "rgba(255, 255, 255, 0.5)";

    this.drawCircle(new Circle({
      type: "scale-topleft",
      x: coordinates.x,
      y: coordinates.y,
      layer: layer
    }), stroke, null, true);

    this.drawCircle(new Circle({
      type: "scale-topright",
      x: coordinates.x + (size.x ? size.x : image.width),
      y: coordinates.y,
      layer: layer
    }), stroke, null, true);

    this.drawCircle(new Circle({
      type: "scale-bottomright",
      x: coordinates.x + (size.x ? size.x : image.width),
      y: coordinates.y + (size.y ? size.y : image.height),
      layer: layer
    }), stroke, null, true);

    this.drawCircle(new Circle({
      type: "scale-bottomleft",
      x: coordinates.x,
      y: coordinates.y + (size.y ? size.y : image.height),
      layer: layer
    }), stroke, null, true);

  };

  // TODO: Gets the appropriate cursor based on mouse position
  Canvas.prototype.getCursor = function(handle) {

    // var cursor = "default";
    //
    // if (handle === null) return cursor;
    //
    // var tailLocation = TextEngine.element.getTailLocation();
    // var isTailTopBottom = tailLocation.side === TextElement.TOP_SIDE || tailLocation.side === TextElement.BOTTOM_SIDE;
    //
    // switch (handle.type) {
    //   case "scale-top":
    //   case "scale-bottom":
    //     cursor = "ns-resize";
    //     break;
    //   case "scale-left":
    //   case "scale-right":
    //     cursor = "ew-resize";
    //     break;
    //   case "scale-top-left":
    //     cursor = "nw-resize";
    //     break;
    //   case "scale-top-right":
    //     cursor = "ne-resize";
    //     break;
    //   case "scale-bottom-left":
    //     cursor = "sw-resize";
    //     break;
    //   case "scale-bottom-right":
    //     cursor = "se-resize";
    //     break;
    //   case "move-tail-left":
    //     cursor = isTailTopBottom ? "w-resize" : "n-resize";
    //     break;
    //   case "move-tail-right":
    //     cursor = isTailTopBottom ? "e-resize" : "s-resize";
    //     break;
    //   case "move-tail-center":
    //   case "move-tail-tip":
    //   case "move-panel":
    //     cursor = "move";
    //     break;
    // }
    //
    // return cursor;

  };

  // Method to set the size of the canvas
  Canvas.prototype.setSize = function(width, height, scale) {
    scale = scale || this.scale || 1;
    this.element.width = width * scale;
    this.element.height = height * scale;
    if (this.layer && this.layer.size) {
      this.layer.size.width = width;
      this.layer.size.height = height;
    }
  };

  // Method to set the scale of the canvas
  Canvas.prototype.setScale = function(scale, saveChange) {
    this.scale = saveChange ? scale : this.scale;
    this.context.scale(scale, scale);
  };

  // Method to get the pixel data at the coordinates
  Canvas.prototype.getPixelData = function(coordinates) {
    // Return if no coordinates are passed
    if (!coordinates || !coordinates.x || !coordinates.y) {
      return;
    }
    // Get the pixel data at the coordinates
    return this.context.getImageData(coordinates.x, coordinates.y, 1, 1).data;
  };

  // Method to get the pixel alpha at the coordinates
  Canvas.prototype.getPixelAlpha = function(coordinates) {
    var data = this.getPixelData(coordinates);
    return data && data[3] ? data[3] : 0;
  };

  // Placeholder for canvas base
  Canvas.base = new Canvas();

  // Public / exposed objects
  return Canvas;

})();
